import React from 'react';
import MobileAdV4HeroSection from '../components/MobileAdV4HeroSection';

const MobileAdV4Page = () => {
  return (
    <div className="min-h-screen">
      <MobileAdV4HeroSection />
    </div>
  );
};

export default MobileAdV4Page;
